const SITE_IMPROVEMENT_ALLOWANCES_SINGLE_WIDE = [
  { item: 'Air Conditioner', standard: 4500, max: 7000 },
  { item: 'Electric Hookups', standard: 2500, max: 3500 },
  { item: 'Water Hookups', standard: 750, max: 1500 },
  { item: 'Sewer Hookups', standard: 750, max: 1500 },
  { item: 'Gas Hookups', standard: 750, max: 1500 },
  { item: 'Steps & Decks (max 3 sets)', standard: 1000, max: 4000 },
  { item: 'Gutters & Downspouts', standard: 1300, max: 1800 },
  { item: 'Delivery & Set', standard: 4500, max: 7500 },
  { item: 'Trim Out', standard: 1500, max: 2500 },
  { section: 'Underpinning Skirting' },
  { item: 'Vinyl', standard: 2000, max: 2000, indent: true, highlight: true },
  { item: 'Metal', standard: 3000, max: 3000, indent: true, highlight: true },
  { item: 'Hardie Board/Insulated', standard: 4000, max: 4000, indent: true, highlight: true },
  { item: 'Masonry', standard: 6000, max: 6000, indent: true, highlight: true },
  { item: 'Footers', standard: 2500, max: 4000 },
  { item: 'Pad', standard: 2500, max: 4000 }
];

const SITE_IMPROVEMENT_ALLOWANCES_DOUBLE_TRIPLE_WIDE = [
  { item: 'Air Conditioner', standard: 4500, max: 7000 },
  { item: 'Electric Hookups', standard: 2500, max: 3500 },
  { item: 'Water Hookups', standard: 750, max: 1500 },
  { item: 'Sewer Hookups', standard: 750, max: 1500 },
  { item: 'Gas Hookups', standard: 750, max: 1500 },
  { item: 'Steps & Decks (max 3 sets)', standard: 1000, max: 4000 },
  { item: 'Gutters & Downspouts', standard: 1300, max: 1800 },
  { item: 'Delivery & Set', standard: 9000, max: 14000 },
  { item: 'Trim Out', standard: 2000, max: 3500 },
  { section: 'Underpinning Skirting' },
  { item: 'Vinyl', standard: 2000, max: 2000, indent: true, highlight: true },
  { item: 'Metal', standard: 3000, max: 3000, indent: true, highlight: true },
  { item: 'Hardie Board/Insulated', standard: 4000, max: 4000, indent: true, highlight: true },
  { item: 'Masonry', standard: 6000, max: 6000, indent: true, highlight: true },
  { item: 'Footers', standard: 5000, max: 8000 },
  { item: 'Pad', standard: 5000, max: 8000 }
];


module.exports = { SITE_IMPROVEMENT_ALLOWANCES_SINGLE_WIDE, SITE_IMPROVEMENT_ALLOWANCES_DOUBLE_TRIPLE_WIDE };
